import { useTheme } from '../context/ThemeContext';

// Icons
const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const StoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
    <path d="M2 7h20" />
  </svg>
);

const BellIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const UsersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const TrophyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </svg>
);

const LocationBottomNav = ({ activeTab, onTabChange }) => {
  const { theme, isDark } = useTheme();

  const tabs = [
    { id: 'trades', icon: CalendarIcon, label: 'Trades' },
    { id: 'shop', icon: StoreIcon, label: 'My Shop' },
    { id: 'notifications', icon: BellIcon, label: 'Alerts' },
    { id: 'staff', icon: UsersIcon, label: 'Staff' },
    { id: 'scoreboard', icon: TrophyIcon, label: 'Rank' },
  ];

  const navStyles = {
    bottomNav: {
      position: 'fixed',
      bottom: 'var(--safe-area-bottom, 0px)',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      padding: '8px 12px',
      backgroundColor: theme.bgPure,
      borderRadius: '40px',
      zIndex: 10000,
      boxShadow: isDark ? 'none' : theme.shadowNav,
      border: isDark ? 'none' : `1px solid ${theme.border}`,
    },
    navBtn: {
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2px',
      cursor: 'pointer',
      color: theme.textSecondary,
      transition: 'all 0.2s ease',
    },
    navBtnActive: {
      backgroundColor: theme.bgCard,
      border: `1px solid #8b5cf6`,
      color: '#8b5cf6',
    },
    navLabel: {
      fontSize: '9px',
      fontWeight: '500',
    },
  };

  return (
    <nav style={navStyles.bottomNav}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            style={{
              ...navStyles.navBtn,
              ...(isActive ? navStyles.navBtnActive : {}),
            }}
            onClick={() => onTabChange(tab.id)}
          >
            <Icon />
            <span style={{
              ...navStyles.navLabel,
              color: isActive ? '#8b5cf6' : 'inherit',
            }}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default LocationBottomNav;
